module.exports = __webpack_public_path__ + "img/2.cd8a8424.png";